import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";

function PaymentLink() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Payment Link" breadcrumbItem="Payment Link" />
          <h4>Payment Link</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default PaymentLink;
